(function () {
  /**
   * This theme already initializes the product gallery from assets/product-single.js.
   * Keep this file "safe": do not call missing functions, and do not crash on resize.
   *
   * If you want: you can remove the <script src="update-slider.js"> include entirely.
   * With this safe version, it can stay without breaking anything.
   */

  function safeDestroySwipers() {
    document.querySelectorAll('.js-media-list, .js-media-sublist').forEach((el) => {
      if (el && el.swiper) {
        el.swiper.destroy(true, true);
      }
    });
  }

  function reInitIfLegacyFunctionsExist() {
    // Only run if your theme still has these legacy init functions somewhere.
    if (typeof window.subSliderInit === 'function') window.subSliderInit(true);
    if (typeof window.sliderInit === 'function') window.sliderInit(true);
  }

  document.addEventListener('shopify:section:load', function () {
    // If Theme Editor reloads a section, product-single.js will init it.
    // We keep this as a no-op safety net.
    reInitIfLegacyFunctionsExist();
  });

  window.addEventListener('resize', function () {
    // Destroy only if swiper exists (prevents console errors).
    safeDestroySwipers();

    // If you still use the legacy init functions, re-init them.
    reInitIfLegacyFunctionsExist();
  });
})();